import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '@app/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class IsGuestGuard implements CanActivate, CanLoad {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isGuest(route.data);
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // canLoad only runs once, the first time the lazy `auth` module is loaded, so it can't rely on
    // the child 'login' route's own `data.forceLogout` (evaluated later via canActivate). Detect a
    // direct/deep link straight into /auth/login here too, so a stale session is always cleared.
    const targetsLogin = segments?.[0]?.path === 'login';
    return this.isGuest(route.data, targetsLogin);
  }

  isGuest(routeData: { [key: string]: any }, forceLogoutOverride = false) {
    const forceLogout = routeData?.forceLogout === true || forceLogoutOverride;
    return this.authService.isSigned().then(async logged => {
			if (logged && forceLogout) {
				await this.authService.logout( true );
				return true;
			}
			if (logged) {
				this.router.navigateByUrl('/');
			}
			return !logged;
		});
  }

}
